"use client";
import {
  Copy,
  FileText,
  ShieldAlert,
  ShieldCheck,
} from "lucide-react";
import {
  type ScanReport,
} from "../../../lib/types";


export function ManifestView({
  report,
  onCopy,
}: {
  report: ScanReport;
  onCopy: (value: string, message?: string) => void;
}) {
  return (
    <div className="manifest-layout">
      <section className="panel">
        <div className="panel-heading">
          <div>
            <div className="section-kicker">STRUCTURED VIEW</div>
            <h3>Manifest attributes</h3>
          </div>
          {report.manifestRaw && (
            <button
              className="text-button"
              type="button"
              onClick={() => onCopy(report.manifestRaw, "Manifest copied")}
            >
              <Copy size={13} />
              Copy raw
            </button>
          )}
        </div>
        {Object.keys(report.manifest).length ? (
          <div className="manifest-table">
            {Object.entries(report.manifest).map(([key, value]) => (
              <div key={key}>
                <code>{key}</code>
                <span>{value}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-panel">
            <FileText size={25} />
            <strong>No JAR manifest found</strong>
            <span>The archive does not expose META-INF/MANIFEST.MF.</span>
          </div>
        )}
      </section>
      <aside className="panel manifest-aside">
        <div className="section-kicker">INTEGRITY</div>
        <h3>Signing material</h3>
        <div className={`signature-state ${report.signed ? "is-signed" : ""}`}>
          {report.signed ? <ShieldCheck size={20} /> : <ShieldAlert size={20} />}
          <span>
            <strong>
              {report.integrity.status === "entry-digests-valid"
                ? "Entry digests match"
                : report.integrity.status === "tampered"
                  ? "Signed contents changed"
                  : report.integrity.status === "incomplete"
                    ? "Incomplete signature"
                    : "Unsigned or unverifiable"}
            </strong>
            <small>
              {report.integrity.notes[0] ??
                "No complete JAR signature set was found."}
            </small>
          </span>
        </div>
        <div className="signature-files">
          {report.signatureFiles.map((path) => (
            <code key={path}>{path}</code>
          ))}
          {!report.signatureFiles.length && <span>No signature files</span>}
        </div>
        <p>
          JarLab verifies manifest entry digests in-browser. Certificate-chain
          authentication still requires the JDK jarsigner tool.
        </p>
      </aside>
    </div>
  );
}
